<aside class="sidebar" [class.collapsed]="collapsed">
  <button
    class="sidebar-collapse-button"
    type="button"
    [attr.title]="collapsed ? 'Развернуть меню' : 'Свернуть меню'"
    [attr.aria-label]="collapsed ? 'Развернуть меню' : 'Свернуть меню'"
    (click)="toggleCollapsed.emit()">
    <svg viewBox="0 0 24 24" aria-hidden="true" [class.collapsed]="collapsed"><path d="m15 18-6-6 6-6"/></svg>
  </button>

  <nav class="sidebar-nav" aria-label="Основная навигация">
    <a class="sidebar-link" routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="notifyNavigation()">
      <span class="sidebar-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/></svg>
      </span>
      <span>Аналитика</span>
    </a>

    <div class="sidebar-section">
      <button class="sidebar-accordion-button" type="button" [class.active]="isSectionActive('crm')" [attr.aria-expanded]="sectionOpen.crm" (click)="toggleSection('crm')">
        <span class="sidebar-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M21 15a4 4 0 0 1-4 4H7l-4 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4Z"/></svg>
        </span>
        <span>CRM</span>
        <svg class="toggle-icon" viewBox="0 0 24 24" aria-hidden="true" [class.open]="sectionOpen.crm"><path d="m6 9 6 6 6-6"/></svg>
      </button>

      <div class="sidebar-subnav" *ngIf="sectionOpen.crm">
        <a class="sidebar-sublink" routerLink="/dashboard/events" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 2v4"/><path d="M16 2v4"/><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18"/><path d="m8 16 2 2 5-5"/></svg></span>
          <span>События</span>
          <strong class="sidebar-badge" *ngIf="activeEventsCount > 0">{{ activeEventsCount }}</strong>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/tickets" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 9V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4"/><path d="M3 15v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4"/><path d="M3 9h18v6H3z"/><path d="M8 12h.01"/></svg></span>
          <span>Билеты</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/clients" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg></span>
          <span>Клиенты</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/mailings" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg></span>
          <span>Рассылки</span>
        </a>
      </div>
    </div>

    <div class="sidebar-section">
      <button class="sidebar-accordion-button" type="button" [class.active]="isSectionActive('apps')" [attr.aria-expanded]="sectionOpen.apps" (click)="toggleSection('apps')">
        <span class="sidebar-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
        </span>
        <span>Приложения</span>
        <svg class="toggle-icon" viewBox="0 0 24 24" aria-hidden="true" [class.open]="sectionOpen.apps"><path d="m6 9 6 6 6-6"/></svg>
      </button>

      <div class="sidebar-subnav" *ngIf="sectionOpen.apps">
        <a class="sidebar-sublink" routerLink="/dashboard/kanban" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 5h4v14H4z"/><path d="M10 5h4v9h-4z"/><path d="M16 5h4v5h-4z"/></svg></span>
          <span>Канбан</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/calendar" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/></svg></span>
          <span>Календарь</span>
        </a>
      </div>
    </div>

    <div class="sidebar-section">
      <button class="sidebar-accordion-button" type="button" [class.active]="isSectionActive('finance')" [attr.aria-expanded]="sectionOpen.finance" (click)="toggleSection('finance')">
        <span class="sidebar-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M4 6h16"/><path d="M6 3h12v18H6z"/><path d="M9 10h6"/><path d="M9 14h4"/></svg>
        </span>
        <span>Финансы</span>
        <svg class="toggle-icon" viewBox="0 0 24 24" aria-hidden="true" [class.open]="sectionOpen.finance"><path d="m6 9 6 6 6-6"/></svg>
      </button>

      <div class="sidebar-subnav" *ngIf="sectionOpen.finance">
        <a class="sidebar-sublink" routerLink="/dashboard/settlements" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 7h13l-3-3"/><path d="m20 7-3 3"/><path d="M17 17H4l3 3"/><path d="m4 17 3-3"/></svg></span>
          <span>Взаиморасчеты</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/orders" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></span>
          <span>Заказы</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/expenses" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 3h16v18H4z"/><path d="M8 7h8"/><path d="M8 11h8"/><path d="M8 15h4"/></svg></span>
          <span>Расходы</span>
        </a>
      </div>
    </div>

    <div class="sidebar-section">
      <button class="sidebar-accordion-button" type="button" [class.active]="isSectionActive('directories')" [attr.aria-expanded]="sectionOpen.directories" (click)="toggleSection('directories')">
        <span class="sidebar-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M3 7h6l2 3h10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"/></svg>
        </span>
        <span>Справочник</span>
        <svg class="toggle-icon" viewBox="0 0 24 24" aria-hidden="true" [class.open]="sectionOpen.directories"><path d="m6 9 6 6 6-6"/></svg>
      </button>

      <div class="sidebar-subnav" *ngIf="sectionOpen.directories">
        <a class="sidebar-sublink" routerLink="/dashboard/championship" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m12 3 2.3 4.6 5.1.7-3.7 3.6.9 5.1-4.6-2.4-4.6 2.4.9-5.1-3.7-3.6 5.1-.7Z"/><path d="M8 21h8"/></svg></span>
          <span>Чемпионаты</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/teams" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m12 3 3 4 5 .7-3.6 3.5.9 5L12 14l-5.3 2.2.9-5L4 7.7 9 7z"/></svg></span>
          <span>Команды</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/season" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/><path d="M8 15h3"/></svg></span>
          <span>Сезон</span>
        </a>
      </div>
    </div>

    <div class="sidebar-section">
      <button class="sidebar-accordion-button" type="button" [class.active]="isSectionActive('system')" [attr.aria-expanded]="sectionOpen.system" (click)="toggleSection('system')">
      <span class="sidebar-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M12.22 2h-.44a2 2 0 0 0-2 2l-.11.67a2 2 0 0 1-2.95 1.21l-.56-.36a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.56.36a2 2 0 0 1 0 3.46l-.56.36a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.56-.36a2 2 0 0 1 2.95 1.21l.11.67a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2l.11-.67a2 2 0 0 1 2.95-1.21l.56.36a2 2 0 0 0 2.73-.73l.22-.38a2 2 0 0 0-.73-2.73l-.56-.36a2 2 0 0 1 0-3.46l.56-.36a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.56.36a2 2 0 0 1-2.95-1.21L14.22 4a2 2 0 0 0-2-2Z"/><circle cx="12" cy="12" r="3"/></svg>
      </span>
        <span>Система</span>
        <svg class="toggle-icon" viewBox="0 0 24 24" aria-hidden="true" [class.open]="sectionOpen.system"><path d="m6 9 6 6 6-6"/></svg>
      </button>

      <div class="sidebar-subnav" *ngIf="sectionOpen.system">
        <a class="sidebar-sublink" routerLink="/dashboard/users" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M19 8v6"/><path d="M16 11h6"/></svg></span>
          <span>Пользователи</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/notifications" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"/><path d="M10 21h4"/></svg></span>
          <span>Оповещения</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/settings" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 7h10"/><path d="M18 7h2"/><path d="M14 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/><path d="M4 17h4"/><path d="M12 17h8"/><path d="M10 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg></span>
          <span>Настройки</span>
        </a>
      </div>
    </div>

    <div class="sidebar-section">
      <button class="sidebar-accordion-button" type="button" [class.active]="isSectionActive('integrations')" [attr.aria-expanded]="sectionOpen.integrations" (click)="toggleSection('integrations')">
        <span class="sidebar-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M8 12h8"/><path d="M12 8v8"/><path d="M5 5a4 4 0 0 1 5.66 0L12 6.34 13.34 5A4 4 0 1 1 19 10.66L17.66 12 19 13.34A4 4 0 1 1 13.34 19L12 17.66 10.66 19A4 4 0 1 1 5 13.34L6.34 12 5 10.66A4 4 0 0 1 5 5Z"/></svg>
        </span>
        <span>Интеграции</span>
        <svg class="toggle-icon" viewBox="0 0 24 24" aria-hidden="true" [class.open]="sectionOpen.integrations"><path d="m6 9 6 6 6-6"/></svg>
      </button>

      <div class="sidebar-subnav" *ngIf="sectionOpen.integrations">
        <a class="sidebar-sublink" routerLink="/dashboard/telegram" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m21 3-7.8 18-3.6-7.4L3 10.2Z"/><path d="m9.6 13.6 4.1-4.1"/></svg></span>
          <span>Telegram</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/minio" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18"/><path d="M7 15h.01"/></svg></span>
          <span>MinIO</span>
        </a>
        <a class="sidebar-sublink" routerLink="/dashboard/bank" routerLinkActive="active" (click)="notifyNavigation()">
          <span class="sidebar-sublink-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m3 10 9-6 9 6"/><path d="M5 10h14"/><path d="M6 10v8"/><path d="M10 10v8"/><path d="M14 10v8"/><path d="M18 10v8"/><path d="M3 20h18"/></svg></span>
          <span>Банк</span>
        </a>
      </div>
    </div>
  </nav>

  <button class="logout-button" type="button" (click)="logout()">
    <span class="sidebar-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/></svg>
    </span>
    <span>Выйти</span>
  </button>
</aside>
